export default class BorrowerHasApplicationsError extends Error {
  constructor(
    readonly borrowerId: string,
    readonly borrowerName: string,
    message?: string,
  ) {
    super(message);
  }
}
